module.exports = __webpack_public_path__ + "img/logo.245a5f76.png";